import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import servicioFormatos from '../servicios/ServicioFormatos';

import servicioReceptor from '../servicios/ServicioReceptor';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioFacturacionEmergencia from '../servicios/ServicioFacturacionEmergencia';
import servicioComplementoIne11 from '../servicios/ServicioComplementoIne11';
import servicioDescargaArchivos from '../servicios/ServicioArchivos';
import servicioHttp from '../servicios/ServicioHttp';
import Receptor from './Receptor';

export class FacturacionEmergencia extends Component {

  constructor() {
    super();
    this.state = {
      listaReceptor: [],
      mostrarMoldaReceptor: false,
      receptor: {},
      erroresRequeridos: {},
      valorencontrado: null,
      listaTabla: null,
      checkboxValue: [],
      ine: {},
      mostrarIne: 'none',
      concepto: {},
      modalConceptos: false,
      comprobante: { total: 0.00, subTotal: 0.00, descuento: 0.00, impuestos: { totalImpuestosTrasladados: 0.00 }, conceptos: { concepto: [] } },
      conceptos: [],
      datoinformativo: {},
      metodoPago: {},
      plaza_cobro: [],
      usosCfdi: [],
      erroresFrmDatos: [],
      urlBusquedaReceptor: 'receptor/buscar_receptor_por_rfc.json',
      urlBusquedaUsosCfdi: 'usocfdi40/uso_cfdi_por_rfc.json',
      urlObtenerElementosIne11: 'ine/obtener_elementos_ine11.json',
      urlDescargaArchivosFacturacion: 'documentos/descargarzip.json',
      elementosComplementoIne: {},
      complementoIne: null,
      desActivarTipoComite: false,
      desActivar_complementoIne_idContabilidad: false,
      desActivar_entidad_claveEntidad: false,
      desActivar_entidad_ambito: false,
      desActivar_entidad_contabilidad_idContabilidad: false,
      erroresFrmDatosFiscales: {},
      mostrarComplementoIne: false,
      confirmacionEliminarConcepto: false,
      listaReceptorConfirmacion: [],
      mostrarModalResultado: false,
      listaResultados: [],
      listaRegimenFiscalReceptor: [],
      urlRegimenFiscal: 'regimen/usocfdi_rfc.json',
      urlValidarReceptor40: 'receptor/validar_receptor40.json'


    }
  }

  actualizaReceptor = (receptor) => {
    this.setState({ receptor });
  }

  actualizaErroresFrmDatosFiscales = (erroresFrmDatosFiscales) => {
    this.setState({ erroresFrmDatosFiscales });
  }

  validarFomularioDatosFiscales = () => {
    let errores = {};
    let { receptor } = this.state;
    console.log(receptor);

    if (!receptor.rfc)
      errores.rfc = "El rfc del receptor es requerido";
    if (!receptor.nombre)
      errores.nombre = "El nombre del receptor es requerido";
    if (!receptor.usoCfdi)
      errores.usoCfdi = "El uso Cfdi es requerido";
    if (!receptor.correo) {
      errores.correo = "El correo es requerido";
    } else {
      this.validarCorreo(receptor.correo, errores);
    }
    if (servicioAsignacionValoresObjetos.esObjetoVacio(receptor.domicilioFiscalReceptor))
      errores.domicilioFiscalReceptor = "El Domicilio Fiscal es requerido";
    if (servicioAsignacionValoresObjetos.esObjetoVacio(receptor.regimenFiscalReceptor))
      errores.regimenFiscalReceptor = "El Regimen Fiscal es requerido";
    console.log(errores);
    return errores;
  }


  validarCorreo = (correo, errores) => {
    var patronCorreo = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const valorvalidacion = patronCorreo.exec(correo);
    if (null === valorvalidacion)
      errores.correo = "Ingrese un correo valido";
  }


  // preguardarReceptor = () => {
  //   this.setState({ receptor: {}, mostrarMoldaReceptor: true });
  // }

  // guardarReceptor = () => {
  //   const { receptor } = this.state;
  //   const resultadoValidacion = this.validarRequeridos(receptor);
  //   this.setState({ erroresRequeridos: resultadoValidacion });
  //   if (!Object.keys(resultadoValidacion).length) {
  //     servicioReceptor.guardarReceptor(receptor).then(response => {
  //       if (response.data.error) {
  //         this.growl.show({ life: 8000, severity: 'error', summary: 'Mensaje', detail: response.data.mensaje });
  //       } else {
  //         this.growl.show({ life: 6000, severity: 'success', summary: '\u00c9xito Mensaje', detail: response.data.mensaje });
  //         this.setState({ receptor: response.data.objeto, mostrarMoldaReceptor: false, erroresRequeridos: {}, listaReceptor: [] });
  //       }
  //     })
  //   }

  // }

  validarRequeridos = (receptor) => {
    const erroresRequeridos = {};
    const mensajesError = [];
    let patron = /^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]{3}$/;

    if (!receptor.rfc) {
      erroresRequeridos.rfc = "El rfc es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Rfc de Receptor', detail: erroresRequeridos.rfc });

    }

    if (!patron.test(receptor.rfc)) {
      mensajesError.push({ life: 7000, severity: 'error', summary: '', detail: 'El RFC no cumple con un patrón válido.  Ejemplo: Persona Física o Persona Moral' });
      erroresRequeridos.rfc = "El rfc es inválido";
    }

    if (!receptor.nombre) {
      erroresRequeridos.nombre = "El nombre es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Nombre de Receptor', detail: erroresRequeridos.nombre });

    }

    if (!receptor.correo) {
      erroresRequeridos.correo = "El correo es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Correo de Receptor', detail: erroresRequeridos.correo });
    }

    if (Object.keys(erroresRequeridos).length) {
      this.growl.show(mensajesError);
    }

    return erroresRequeridos;
  }

  asignarValoresObjeto = (event) => {
    if (event.target.id === "correo")
      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    else
      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
  }

  // buscarRfcReceptor = () => {
  //   let { receptor } = this.state;
  //   servicioReceptor.comprobarSiExisteReceptor(receptor).then(response => {
  //     if (response.data.error) {
  //       this.growl.show({ life: 6000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
  //       receptor['rfc'] = '';
  //       this.setState({ receptor: receptor });
  //     }
  //   });
  // }

  obtener_regimen_fiscal = () => {
    let { receptor } = this.state;
    servicioHttp.consumirPostHttpBasic('regimen/buscar_regimen_fiscal_uso_cfdi.json', {
      'rfc': receptor.rfc,
      'usoCfdi': receptor.usoCfdi.clave
    }).then(response => {
      this.setState({ listaRegimenFiscalReceptor: response.data.lista });
    });
  }

  buscarReceptorLike = (valor) => {
    setTimeout(() => {

      if (valor.query.length === 0) {

      }
      else {
        servicioReceptor.buscarReceptorLike({ rfc: valor.query.toUpperCase() }).then(response => {
          if (response.data.error) {
            this.growl.show({ life: 6000, severity: 'error', summary: 'Mensaje', detail: response.data.mensaje });
            this.setState({ valorencontrado: response.data.lista });
          } else {
            this.growl.show({ life: 1000, severity: 'success', summary: '\u00c9xito Mensaje', detail: response.data.mensaje });
            this.setState({ valorencontrado: response.data.lista });
          }
        }).catch((error) => {
          this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'El servidor no responde' });
        });
      }

    }, 250);
  }


  // cargarValores = (event) => {
  //   if (event.value.rfc !== undefined) {
  //     const { receptor } = this.state;
  //     receptor['rfc'] = event.value.rfc;
  //     this.setState({ receptor });
  //     this.setState({ listaTabla: [event.value] });
  //     this.buscarReceptor();
  //   }
  //   this.setState({ listaReceptor: event.value })
  // }

  // columnaEditarReceptor = (rowData, column) => {
  //   return <div>
  //     <Button tooltip="Editar receptor" type="button" icon="pi-md-edit" className="p-button-warning" onClick={this.preEditarReceptor.bind(this, rowData)}></Button>
  //   </div>;
  // }

  // columnaEliminarConcepto = (rowData, column) => {
  //   return <div>
  //     <Button tooltip="Eliminar concepto" type="button" icon="pi-md-delete" className="p-button-warning" onClick={this.preEliminarConcept.bind(this, rowData)}></Button>
  //   </div>;
  // }

  // preEditarReceptor = (objeto) => {
  //   this.setState({ receptor: objeto, mostrarMoldaReceptor: true });
  // }

  preEliminarConcept = (objeto) => {
    const { conceptos } = this.state;
    const index = conceptos.findIndex(concepto => concepto === objeto);
    this.setState({ conceptos: conceptos, indexConcepto: index, confirmacionEliminarConcepto: true, concepto: objeto });

  }

  crearEliminarComplmentoIne = (e) => {

    let elComplementoIne = null;
    if (true === e.checked) {
      let { urlObtenerElementosIne11 } = this.state;
      console.log(urlObtenerElementosIne11);
      elComplementoIne = {};
      servicioComplementoIne11.obtenerElementosIne11(urlObtenerElementosIne11).then(response => {
        this.setState({ elementosComplementoIne: response.data });
      }).catch(error => {

      });
    }
    this.setState({ mostrarComplementoIne: e.checked });
    this.setState({ complementoIne: elComplementoIne });
  }

  nuevoConcepto = () => {
    let { receptor } = this.state;
    console.log("receptor lleno :D");
    console.log(receptor);

    servicioFacturacionEmergencia.plazas_asignadas_emisor().then(response => {
      if (response.data.error)
        this.growl.show({ life: 6000, severity: 'error', summary: 'error', detail: response.data.mensaje });
      else
        this.setState({ plaza_cobro: response.data.lista, concepto: { cantidad: 0.00, total: 0.00, importe: 0.00, unidad: "PEAJE" }, modalConceptos: true, botonNuevoConcepto: true, datoinformativo: {}, metodoPago: {}, plazacobro: {} });
    });
  }

  guardarConcepto = () => {
    let { comprobante, concepto, conceptos, datoinformativo, metodoPago, plazacobro } = this.state;
    const resultadoValidacion = this.validar_formulario_concepto(concepto, datoinformativo, metodoPago, plazacobro);
    this.setState({ erroresRequeridos: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {
      concepto['datoInformativo'] = datoinformativo.name;
      concepto['metodoPago'] = metodoPago.code;
      conceptos.push(concepto);
      servicioFacturacionEmergencia.obtner_comprobante({ comprobante: comprobante, emergencia: conceptos }).then(response => {
        console.log(response.data);
        this.setState({ conceptos: response.data.objeto.emergencia, modalConceptos: false, comprobante: response.data.objeto.comprobante });
      })
    }

  }

  buscar_plaza_folio_total = () => {
    const { concepto } = this.state;

    if (concepto.plazaCobro === undefined)
      concepto['plazaCobro'] = { numero: null };
    servicioFacturacionEmergencia.buscar_plaza_folio_total({ total: concepto.total, folio: concepto.folio, plazaCobro: concepto.plazaCobro.numero }).then(response => {
      if (response.data.error) {
        concepto['importe'] = '';
        concepto['folio'] = null;
        concepto['plazaCobro'] = undefined;
        concepto['total'] = null;
        this.setState({ concepto });
        this.growl.show({ life: 7000, severity: 'error', summary: 'error', detail: response.data.mensaje });
      }
    });
  }

  realizar_calculos_cantidad_total = () => {
    let { concepto } = this.state;
    servicioFacturacionEmergencia.realizar_calculos_cantidad_total(concepto).then(response => {
      if (response.data.error)
        this.growl.show({ life: 3000, severity: 'error', summary: 'error', detail: response.data.mensaje });
      else
        this.setState({ concepto: response.data.objeto });

    });

    this.buscar_plaza_folio_total();
  }

  validar_formulario_concepto = (concepto, datoinformativo, metodoPago, plazacobro) => {
    const erroresConcepto = {};
    if (!datoinformativo.code)
      erroresConcepto.datoinformativo = "Dato Informativo es requerido";

    if (!metodoPago.code)
      erroresConcepto.metodoPago = "Metodo de Pago es requerido";

    if (!concepto.cantidad)
      erroresConcepto.cantidad = "Cantidad es requerida";

    if (!concepto.importe)
      erroresConcepto.importe = "Total con iva es requerido";
    if (!concepto.folio)
      erroresConcepto.folio = "Folio es requerido";

    console.log(concepto.plazaCobro);
    if (!concepto.plazaCobro || concepto.plazaCobro === undefined)
      erroresConcepto.plazacobro = "Plaza de cobro requerido";

    return erroresConcepto;
  }

  validar_plaza_cobro = (e) => {
    const { concepto } = this.state;
    concepto['plazaCobro'] = e.target.value;
    this.setState({ concepto });
    this.buscar_plaza_folio_total();
  }

  columna_valor_unitario = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.valorUnitario)}</div>;
  }

  columna_costo = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.importe)}</div>;

  }

  total_iva = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.totalIva)}</div>;
  }

  total = (rowData, column) => {
    return <div style={{ backgroundColor: '#00bcd4' }}>{servicioFormatos.formatearModena(rowData.total)}</div>;
  }

  templateUsoCfdi = (option) => {
    return (
      <div className="p-clearfix">
        <span >{option.clave} - {option.descripcion}</span>
      </div>
    );
  }

  validarTipoComite = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    let { complementoIne } = this.state;
    if (null !== complementoIne) {
      if ("Ejecutivo Nacional" === complementoIne.tipoComite.llave) {
        this.setState({ desActivar_complementoIne_idContabilidad: false });
        complementoIne.entidad_claveEntidad = null;
        complementoIne.entidad_ambito = null;
        complementoIne.entidad_contabilidad_idContabilidad = null;
        this.setState({ desActivar_entidad_claveEntidad: true });
        this.setState({ desActivar_entidad_ambito: true });
        this.setState({ desActivar_entidad_contabilidad_idContabilidad: true });
      } else if ("Ejecutivo Estatal" === complementoIne.tipoComite.llave) {
        complementoIne.idContabilidad = null;
        complementoIne.entidad_ambito = null;
        this.setState({ desActivar_complementoIne_idContabilidad: true });
        this.setState({ desActivar_entidad_claveEntidad: false });
        this.setState({ desActivar_entidad_ambito: true });
        this.setState({ desActivar_entidad_contabilidad_idContabilidad: false });
      } else if ("Directivo Estatal" === complementoIne.tipoComite.llave) {
        complementoIne.idContabilidad = null;
        complementoIne.entidad_ambito = null;
        this.setState({ desActivar_complementoIne_idContabilidad: false });
        this.setState({ desActivar_entidad_claveEntidad: false });
        this.setState({ desActivar_entidad_ambito: true });
        this.setState({ desActivar_entidad_contabilidad_idContabilidad: false });
      }

      this.setState({ complementoIne: complementoIne });
    }
  }

  validarTipoProceso = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    let { complementoIne } = this.state;
    if (null !== complementoIne) {
      if ("Ordinario" === complementoIne.tipoProceso.llave) {
        this.setState({ desActivarTipoComite: false });
        this.setState({ desActivar_complementoIne_idContabilidad: false });
      } else {
        complementoIne.tipoComite = null;
        complementoIne.idContabilidad = null;
        this.setState({ desActivarTipoComite: true });
        this.setState({ desActivar_complementoIne_idContabilidad: true });
        complementoIne.entidad_claveEntidad = null;
        complementoIne.entidad_ambito = null;
        complementoIne.entidad_contabilidad_idContabilidad = null;
        this.setState({ desActivar_entidad_claveEntidad: false });
        this.setState({ desActivar_entidad_ambito: false });
        this.setState({ desActivar_entidad_contabilidad_idContabilidad: false });
      }
    }
  }

  prefactura = () => {
    let { receptor, conceptos } = this.state;
    const errores = this.validar_facturacion(receptor, conceptos);
    this.setState({ erroresFrmDatos: errores });
    if (!Object.keys(errores).length) {
      let erroresFrmDatosFiscales = this.validarFomularioDatosFiscales();
      this.setState({ erroresFrmDatosFiscales: erroresFrmDatosFiscales });
      if (!Object.keys(erroresFrmDatosFiscales).length) {
        let receptorEnvio = {rfc:receptor.rfc,nombre:receptor.nombre,domicilioFiscalReceptor:receptor.domicilioFiscalReceptor,regimenFiscalReceptor:receptor.regimenFiscalReceptor.id,usoCfdi:receptor.usoCfdi.id};
        servicioHttp.consumirPostHttp("receptor/validar_receptor40.json",receptorEnvio).then(response=>{
            let validacionDatosFiscales=response.data.error;
            if(validacionDatosFiscales){
                this.growl.show({ severity: 'error', summary: 'Error', detail: response.data.mensaje,life: 5000  });
            }else{
              this.setState({ confirmacionFacturacion: true, listaReceptorConfirmacion: [receptor] });
            }
        })
      }
    }
  }

  validar_facturacion = (receptor, conceptos) => {
    const erroresConcepto = {};
    const mensajesError = [];
    if (!receptor.rfc) {
      erroresConcepto.rfc = "El receptor es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Receptor', detail: erroresConcepto.rfc });
    }


    if (conceptos.length === 0) {
      erroresConcepto.conceptos = "Debes agregar un concepto requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Concepto', detail: erroresConcepto.conceptos });
    }

    if (!receptor.usoCfdi) {
      erroresConcepto.usoCfdi = "El uso del CFDI es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message usoCfdi', detail: erroresConcepto.cantidad });
    }


    if (!receptor.regimenFiscalReceptor) {
      erroresConcepto.regimenFiscalReceptor = "El Regimen Fiscal es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message usoCfdi', detail: erroresConcepto.regimenFiscalReceptor });
    }


    if (Object.keys(erroresConcepto).length) {
      this.growl.show(mensajesError);
    }
    return erroresConcepto;

  }

  cerrar_modal_confirmacion_eliminar_concepto = () => {
    this.setState({ confirmacionEliminarConcepto: false });
  }

  cerrar_modal_confirmacion_facturacion = () => {
    this.setState({ confirmacionFacturacion: false });
  }

  eliminar_concepto = () => {
    let { conceptos, comprobante, indexConcepto, concepto } = this.state;
    servicioFacturacionEmergencia.eliminar_concepto({ total: concepto.total, folio: concepto.folio, plazaCobro: concepto.plazaCobro.numero }).then(response => {
      conceptos.splice(indexConcepto, 1);
      servicioFacturacionEmergencia.obtner_comprobante({ comprobante: comprobante, emergencia: conceptos }).then(response => {
        console.log(response.data);
        this.setState({ conceptos: response.data.objeto.emergencia, modalConceptos: false, comprobante: response.data.objeto.comprobante, confirmacionEliminarConcepto: false });
      })

    });
  }

  columna_uso_cfdi = (rowData, column) => {
    console.log(rowData);
    return (
      <div className="p-clearfix">
        <span >{rowData.usoCfdi.id} - {rowData.usoCfdi.descripcion}</span>
      </div>
    );

  }

  facturar = () => {
    const { comprobante, receptor, conceptos } = this.state;
    var receptorEnvio = JSON.parse(JSON.stringify(receptor));
    let usoCfdi = receptorEnvio.usoCfdi.id;
    delete receptorEnvio['usoCfdi'];
    receptorEnvio.usoCfdi = usoCfdi;
    let regimenFiscalReceptor = receptorEnvio.regimenFiscalReceptor.id;
    delete receptorEnvio['regimenFiscalReceptor'];
    receptorEnvio.regimenFiscalReceptor = regimenFiscalReceptor;
    this.obtenerComplementoIne(receptorEnvio);
    servicioFacturacionEmergencia.facturacion_emergencia({ comprobante: comprobante, receptor: receptorEnvio, emergencia: conceptos }).then(response => {
      let respuesta = response.data;
      let listaResultados = respuesta.lista;
      this.setState({ mostrarModalResultado: true });
      this.setState({
        listaResultados: listaResultados, comprobante: { total: 0.00, subTotal: 0.00, descuento: 0.00, impuestos: { totalImpuestosTrasladados: 0.00 }, conceptos: { concepto: [] } },
        conceptos: [], receptor: {}, listaReceptor: [], listaTabla: [], listaReceptorConfirmacion: []
      });
      this.cerrar_modal_confirmacion_facturacion();
    });
  }

  obtenerComplementoIne = (receptor) => {
    let { complementoIne } = this.state;
    if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne)) {
      let complementoIne1_1 = {};
      complementoIne1_1.version = "1.1";
      if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne.tipoProceso))
        complementoIne1_1.tipoProceso = complementoIne.tipoProceso.valor;

      if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne.tipoComite))
        complementoIne1_1.tipoComite = complementoIne.tipoComite.valor;

      if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne.idContabilidad))
        complementoIne1_1.idContabilidad = complementoIne.idContabilidad;

      let entidad = {};
      if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne.entidad_claveEntidad))
        entidad.claveEntidad = complementoIne.entidad_claveEntidad.valor;

      if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne.entidad_ambito))
        entidad.ambito = complementoIne.entidad_ambito.valor;

      let inde_entidad_contabilidad = {};
      if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne.entidad_contabilidad_idContabilidad))
        inde_entidad_contabilidad.idContabilidad = complementoIne.entidad_contabilidad_idContabilidad;

      if (!servicioAsignacionValoresObjetos.esObjetoVacio(inde_entidad_contabilidad)) {
        entidad.contabilidad = [];
        entidad.contabilidad[0] = inde_entidad_contabilidad;
      }

      if (!servicioAsignacionValoresObjetos.esObjetoVacio(entidad)) {
        complementoIne1_1.entidad = [];
        complementoIne1_1.entidad[0] = entidad;
      }

      if (!servicioAsignacionValoresObjetos.esObjetoVacio(complementoIne1_1))
        receptor.ine11 = complementoIne1_1;
    }
  }

  cerrarModalResultados = () => {
    this.setState({ mostrarModalResultado: false });
  }

  templateDescargaArchivos = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi-md-cloud-download" className="p-button-success" onClick={(e) => this.descargaArchivos(rowData)}></Button>
    </div>;
  }

  descargaArchivos = (rowData) => {
    let { urlDescargaArchivosFacturacion } = this.state;
    servicioDescargaArchivos.descargaArchivo(urlDescargaArchivosFacturacion, { id: rowData.objeto.busqueda });
  }


  templateErrorResultado = (rowData, column) => {
    if (rowData.error === true)
      return <div className="p-col-12 p-md-2"><i className="pi-md-cancel"></i></div>;
    else
      return <div className="p-col-12 p-md-2"><i className="pi-md-check-circle"></i></div>;
  }

  render() {

    let { erroresRequeridos, receptor, concepto, plaza_cobro, comprobante, elementosComplementoIne, complementoIne,
      desActivarTipoComite, desActivar_complementoIne_idContabilidad, desActivar_entidad_claveEntidad, desActivar_entidad_ambito,
      desActivar_entidad_contabilidad_idContabilidad, erroresFrmDatosFiscales, mostrarComplementoIne, listaReceptorConfirmacion, mostrarModalResultado, listaResultados, urlBusquedaReceptor, urlRegimenFiscal, urlBusquedaUsosCfdi, urlObtenerElementosIne11 } = this.state;

    // const dialogFooter = (
    //   <div>
    //     <Button icon="pi-md-check" onClick={this.guardarReceptor} label="Guardar" className="teal-btn flat-btn" />
    //     <Button icon="pi-md-close" onClick={() => this.setState({ receptor: {}, mostrarMoldaReceptor: false, erroresRequeridos: {} })} label="Cancelar" className="p-button-danger flat-btn" />
    //   </div>
    // );

    const dialogFooterConcepto = (
      <div>
        <Button icon="pi-md-check" onClick={this.guardarConcepto} label="Guardar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={() => this.setState({ concepto: { cantidad: 0.00, importe: 0.00, unidad: "PEAJE" }, modalConceptos: false })} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );

    const dialogFooterConfirmacionEliminarConcepto = (
      <div>
        <Button icon="pi-md-check" onClick={this.eliminar_concepto} label="Si estoy seguro" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrar_modal_confirmacion_eliminar_concepto} label="No estoy seguro" className="p-button-danger flat-btn" />
      </div>
    );

    const dialogFooterConfirmacionFacturacion = (
      <div>
        <Button icon="pi-md-check" onClick={this.facturar} label="Facturar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrar_modal_confirmacion_facturacion} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );

    const piePaginaModalRestultados = (
      <div>
        <Button label="Cerrar" icon="pi pi-times" onClick={this.cerrarModalResultados} />
      </div>
    );

    const dato_informativo = [
      { name: 'Comprobante ilegible', code: 1 },
      { name: 'Comprobante sin codigo', code: 2 },
      { name: 'Comprobante de meses anteriores', code: 3 },
      { name: 'Ticket de emergencia', code: 4 }
    ];

    const metodo_pago = [
      { name: 'Efectivo', code: "0" },
      { name: 'Tarjeta de Crédito', code: "1" },
      { name: 'Tarjeta de Débito', code: "2" }
    ];

    return (<div>
      <div className="content-section implementation">
        <Growl ref={(el) => this.growl = el} />
        <div className="card card-w-title">
          <h1 style={{ marginBottom: '30px' }}>Facturación de Tickets de Emergencia</h1>
          <Receptor receptor={receptor} erroresFrmDatosFiscales={erroresFrmDatosFiscales} urlBusquedaReceptor={urlBusquedaReceptor} urlRegimenFiscal={urlRegimenFiscal} urlBusquedaUsosCfdi={urlBusquedaUsosCfdi} urlObtenerElementosIne11={urlObtenerElementosIne11} actualizaReceptor={this.actualizaReceptor} actualizaErroresFrmDatosFiscales={this.actualizaErroresFrmDatosFiscales} />

        </div>
      </div>

      <br />

      <div className="p-grid" style={{ width: '100%' }}>
        <div className="p-col-12 p-md-2">
          <label htmlFor="domicilio"> Pertenezco a algún partido político</label>
        </div>
        <div className="p-col-12 p-md-10">
          <Checkbox inputId="cb1" value="Pertenezco a algún partido político" checked={mostrarComplementoIne} onChange={this.crearEliminarComplmentoIne}></Checkbox>
        </div>
      </div>

      {mostrarComplementoIne ? <div className="card card-w-title">
        <h3 style={{ marginBottom: '20px' }}>Complemento INE</h3>
        <div className="p-grid">
          <div className="p-col-12 p-md-2" style={{ width: '13%' }}>
            <label htmlFor="tipoproceso">Tipo Proceso:</label>
          </div>
          <div className="p-col-12 p-md-2">
            <Dropdown dataKey="llave" id="tipoproceso" name="complementoIne.tipoProceso" placeholder="Selecciona" options={elementosComplementoIne.tiposProceso} value={complementoIne.tipoProceso} onChange={this.validarTipoProceso} optionValue="llave" optionLabel="valor" />
          </div>
          <div className="p-col-12 p-md-2" style={{ width: '14%' }}>
            <label htmlFor="tipoComite">Tipo Comité:</label>
          </div>
          <div className="p-col-12 p-md-2">
            <Dropdown dataKey="llave" id="tipoComite" name="complementoIne.tipoComite" placeholder="Selecciona" options={elementosComplementoIne.tiposComite} value={complementoIne.tipoComite} onChange={this.validarTipoComite} optionValue="llave" optionLabel="valor" disabled={desActivarTipoComite} />
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="idContabilidad">Id Contabilidad:</label>
          </div>
          <div className="p-col-12 p-md-2">
            <InputText id="idContabilidad" name="complementoIne.idContabilidad" value={complementoIne.idContabilidad || ''} onChange={this.asignarValoresObjeto} placeholder="Id Contabilidad" keyfilter="pint" disabled={desActivar_complementoIne_idContabilidad} maxlength="6" />
            {erroresFrmDatosFiscales.rfc ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.rfc} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2" style={{ width: '13%' }}>
            <label htmlFor="claveEntidad">Clave Entidad:</label>
          </div>
          <div className="p-col-12 p-md-2">
            <Dropdown dataKey="llave" id="entidad" name="complementoIne.entidad_claveEntidad" placeholder="Selecciona" options={elementosComplementoIne.clavesEntidad} value={complementoIne.entidad_claveEntidad} onChange={this.asignarValoresObjeto} optionValue="llave" optionLabel="valor" disabled={desActivar_entidad_claveEntidad} />
            {erroresFrmDatosFiscales.usoCfdi ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.usoCfdi} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2" style={{ width: '14%' }}>
            <label htmlFor="rfc">Ambito:</label>
          </div>
          <div className="p-col-12 p-md-2">
            <Dropdown dataKey="llave" id="ambito" name="complementoIne.entidad_ambito" placeholder="Selecciona" options={elementosComplementoIne.tiposAmbito} value={complementoIne.entidad_ambito} onChange={this.asignarValoresObjeto} optionValue="llave" optionLabel="valor" disabled={desActivar_entidad_ambito} />
            {erroresFrmDatosFiscales.usoCfdi ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.usoCfdi} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="rfc">Entidad Id Contabilidad:</label>
          </div>
          <div className="p-col-12 p-md-2">
            <InputText id="entidad_contabilidad_idContabilidad" name="complementoIne.entidad_contabilidad_idContabilidad" value={complementoIne.entidad_contabilidad_idContabilidad || ''} onChange={this.asignarValoresObjeto} placeholder="Entidad Id Contabilidad" keyfilter="pint" disabled={desActivar_entidad_contabilidad_idContabilidad} maxlength="6" />
          </div>
        </div>
      </div> : null}


      <div className="card card-w-title">
        <div className="p-grid p-fluid" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', marginTop: '10px' }}>
          <div className="p-col-12  p-md-4">
            <Button label="Nuevo Concepto" className="blue-grey-btn flat-btn" onClick={this.nuevoConcepto} />
          </div>
        </div>
        <div className="p-col-12">
          <DataTable value={this.state.conceptos} header="CONCEPTOS O SERVICIOS DEL COMPROBANTE" responsive={true}>
            <Column style={{ textAlign: 'center' }} header="Eliminar" body={this.columnaEliminarConcepto} autoLayout={true} />
            <Column style={{ textAlign: 'center' }} field="cantidad" header="Cantidad" autoLayout={true} />
            <Column style={{ textAlign: 'center' }} field="unidad" header="Unidad" autoLayout={true} />
            <Column style={{ textAlign: 'center' }} field="descripcion" header="Descripción" autoLayout={true} />
            <Column style={{ textAlign: 'center' }} body={this.columna_valor_unitario} header="Valor Unitario" autoLayout={true} />
            <Column style={{ textAlign: 'center' }} body={this.columna_costo} header="Costo" autoLayout={true} />
            <Column style={{ textAlign: 'center' }} body={this.total_iva} header="Iva" autoLayout={true} />
            <Column style={{ textAlign: 'center' }} body={this.total} header="Total" autoLayout={true} />
          </DataTable>

        </div>
      </div>

      <Dialog header="Conceptos, los campos con * son requeridos." blockScroll visible={this.state.modalConceptos} modal={true} footer={dialogFooterConcepto} style={{ width: '60vw' }} onHide={() => this.setState({ concepto: { cantidad: 0.00, importe: 0.00, unidad: "PEAJE" }, modalConceptos: false, erroresRequeridos: {}, datoinformativo: {}, metodoPago: {} })}>

        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-2">
            <label htmlFor="cantidad">* Cantidad:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <InputText id="cantidad" name="concepto.cantidad" value={concepto.cantidad || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.cantidad ? 'p-error' : ''} onBlur={this.realizar_calculos_cantidad_total} />
            {erroresRequeridos.cantidad ? <div> <Message severity="error" text={erroresRequeridos.cantidad} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="datoInformativo">* Dato Informativo:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <Dropdown id="datoinformativo" value={this.state.datoinformativo} options={dato_informativo} onChange={(e) => this.setState({ datoinformativo: e.target.value })} optionLabel="name" placeholder="Selecciona" autoWidth={false} />
            {erroresRequeridos.datoinformativo ? <div> <Message severity="error" text={erroresRequeridos.datoinformativo} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="textarea">* Total con Iva:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <InputText id="importe" name="concepto.importe" value={concepto.importe || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.importe ? 'p-error' : ''} onBlur={this.realizar_calculos_cantidad_total} />
            {erroresRequeridos.importe ? <div> <Message severity="error" text={erroresRequeridos.importe} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="textarea">Unidad:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <div className="count" style={{ backgroundColor: '#ffc107' }}>{concepto.unidad}</div>
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="textarea">Folio:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <InputText id="folio" name="concepto.folio" value={concepto.folio || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.folio ? 'p-error' : ''} onBlur={this.buscar_plaza_folio_total} />
            {erroresRequeridos.folio ? <div> <Message severity="error" text={erroresRequeridos.folio} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="importe">Importe:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <div className="count" style={{ backgroundColor: '#00bcd4' }}>{servicioFormatos.formatearModena(concepto.total)}</div>
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="plazaCobro">* Plaza de Cobro:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <Dropdown id="plazacobro" value={concepto.plazaCobro || ''} options={plaza_cobro} onChange={this.validar_plaza_cobro} optionLabel="nombre" placeholder="Selecciona" autoWidth={false} />
            {erroresRequeridos.plazacobro ? <div> <Message severity="error" text={erroresRequeridos.plazacobro} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="metodoPago">* Método Pago:</label>
          </div>
          <div className="p-col-12 p-md-4">
            <Dropdown id="metodoPago" value={this.state.metodoPago} options={metodo_pago} onChange={(e) => this.setState({ metodoPago: e.target.value })} optionLabel="name" placeholder="Selecciona" autoWidth={false} />
            {erroresRequeridos.metodoPago ? <div> <Message severity="error" text={erroresRequeridos.metodoPago} /> </div> : null}
          </div>
        </div>
      </Dialog>
      <h3 style={{ marginTop: '40px', marginBottom: '20px' }}><label>Importe sobre el comprobante</label></h3>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-4" style={{ textAlign: 'center' }}>
          <h4>Subtotal</h4>
          <p>{servicioFormatos.formatearModena(comprobante.subTotal)}</p>
        </div>
        <div className="p-col-12 p-md-4" style={{ textAlign: 'center' }}>
          <h4>IVA</h4>
          <p>{servicioFormatos.formatearModena(comprobante.impuestos.totalImpuestosTrasladados)}</p>
        </div>
        <div className="p-col-12 p-md-4" style={{ textAlign: 'center' }}>
          <h4>Total</h4>
          <p>{servicioFormatos.formatearModena(comprobante.total)}</p>
        </div>


      </div>

      <Dialog header="Confirmación" visible={this.state.confirmacionEliminarConcepto} modal={true} style={{ width: '30vw' }} footer={dialogFooterConfirmacionEliminarConcepto} onHide={this.cerrar_modal_confirmacion_eliminar_concepto}>
        <h2>¿Estás seguro de eliminar el concepto?</h2>
      </Dialog>

      <center>
        <div className="p-grid p-fluid" style={{ marginTop: '40px', width: '60%', marginBottom: '60px' }}>
          <div className="p-col-12">
            <Button label="Generar Comprobante" className="indigo-btn flat-btn" onClick={this.prefactura} style={{ width: '50%' }} />
          </div>
        </div>
      </center>

      <Dialog header="Confirmación Facturación" visible={this.state.confirmacionFacturacion} modal={true} style={{ width: '80vw' }} footer={dialogFooterConfirmacionFacturacion} onHide={this.cerrar_modal_confirmacion_facturacion}>
        <DataTable value={listaReceptorConfirmacion} paginatorPosition="both" selectionMode="single" header="Datos del Receptor" responsive={true}>
          <Column field="rfc" header="R.F.C" sortable={true} />
          <Column field="nombre" header="Nombre o Razón Social" sortable={true} />
          <Column body={this.columna_uso_cfdi} header="UsoCfdi" sortable={true} />
          <Column field="correo" header="Correo" sortable={true} />
        </DataTable>
        <DataTable value={this.state.conceptos} header="Conceptos o Servicios del Comprobante" responsive={true}>
          <Column field="cantidad" header="Cantidad" autoLayout={true} />
          <Column field="unidad" header="Unidad" autoLayout={true} />
          <Column field="descripcion" header="Descripción" autoLayout={true} />
          <Column body={this.columna_valor_unitario} header="Valor Unitario" autoLayout={true} />
          <Column body={this.columna_costo} header="Costo" autoLayout={true} />
          <Column body={this.total_iva} header="Iva" autoLayout={true} />
          <Column body={this.total} header="Total" autoLayout={true} />
        </DataTable>
      </Dialog>

      <Dialog header="Resultado facturación" visible={mostrarModalResultado} style={{ width: '50vw' }} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalRestultados} onHide={this.cerrarModalResultados}>
        <DataTable value={listaResultados} header="Facturas generadas" responsive={true}>
          <Column body={this.templateErrorResultado} header="Estado" />
          <Column field="mensaje" header="Observación" />
          <Column field="objeto.uuid" header="UUID" />
          <Column field="objeto.serie" header="Serie" />
          <Column field="objeto.folio" header="Folio" />
          <Column body={this.templateDescargaArchivos} style={{ textAlign: 'center', width: '8em' }} header="Descargar archivos" />
        </DataTable>
      </Dialog>


    </div>);
  }
}